import { Button, Modal, Space } from "antd";
import { AttendeeItineraryItemResponseModel, AttendeeItinerarySpeakerDeleteOptions } from "generated/api";
import React, { FC, useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.less";

interface AttendeeItineraryDeleteOptionsProps {
  record: AttendeeItineraryItemResponseModel;
  onDelete: (id: number, option: AttendeeItinerarySpeakerDeleteOptions) => Promise<void>;
}

const AttendeeItineraryDeleteOptions: FC<AttendeeItineraryDeleteOptionsProps> = ({ record, onDelete }) => {
  const { t } = useTranslation();
  const [deletingOption, setDeletingOption] = useState<AttendeeItinerarySpeakerDeleteOptions>();

  const deleteItinerary = async (option: AttendeeItinerarySpeakerDeleteOptions) => {
    setDeletingOption(option);

    try {
      await onDelete(record.id, option);
      Modal.destroyAll();
    } finally {
      setDeletingOption(undefined);
    }
  };

  return (
    <Space className={styles.modalButtonWrapper}>
      <Button
        key="session"
        loading={deletingOption === AttendeeItinerarySpeakerDeleteOptions.DeleteSession}
        disabled={!!deletingOption}
        onClick={() => deleteItinerary(AttendeeItinerarySpeakerDeleteOptions.DeleteSession)}
      >
        {t("This session")}
      </Button>
      <Button
        key="speaker"
        loading={deletingOption === AttendeeItinerarySpeakerDeleteOptions.OnlySpeaker}
        disabled={!!deletingOption}
        onClick={() => deleteItinerary(AttendeeItinerarySpeakerDeleteOptions.OnlySpeaker)}
      >
        {t("Only speaker")}
      </Button>
    </Space>
  );
};

export default AttendeeItineraryDeleteOptions;
